import styled from "@emotion/styled";

import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const Root = styled.div({
    display: "inline-block",
    marginLeft: 10,
});

export const Label = styled.span(props => ({
    ...theme(props).typography.secondary.css(),
}));

export const Spacer = styled.span(props => ({ display: "inline-block", width: theme(props).size(1) }));

export const EditIconWrapper = styled.span(props => ({
    color: theme(props).typography.link.color,
    marginLeft: 10,
}));
